module.exports = __webpack_public_path__ + "assets/img/two.8cd5abd4.jpg";